import type { MissingInformationDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/missingInformation';
import { selector } from 'recoil';
import { getMissingInformationDTO } from '../../utils/missingInfoUtil';
import { allCoverablesAtom } from './../atoms/allCoverablesAtom';
import { refreshMissingInformationAtom } from '../atoms/refreshMissingInformationAtom';

export const getMissingInformationSelector = selector<MissingInformationDTO>({
    key: 'getMissingInformationSelector',
    get: ({ get }) => {
        const coverables = get(allCoverablesAtom);
        get(refreshMissingInformationAtom);
        return getMissingInformationDTO(coverables);
    }
});
